export default __webpack_public_path__ + "static/media/0x0b6afe834dab840335f87d99b45c2a4bd81a93c7.5c605d6a.webp";